import actions from './actions'

const initialState = {
  data: [],
  isFetching: false,
  error: '',
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_USERS: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }

    case actions.FETCH_USERS_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
        error: '',
      }
    }

    case actions.FETCH_USERS_ERROR: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case actions.USER_SET: {
      return {
        ...state,
        data: action.data,
        isSaving: true,
        error: '',
      }
    }

    case actions.USER_ADD: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.USER_DEL: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.USER_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        error: '',
      }
    }

    case actions.USER_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    default: {
      return state
    }
  }
}
